import { useMapEvents } from "react-leaflet/hooks";
import { useMapContext } from "./MapContext";
import { useDispatch } from "react-redux";
import { setMapZoom } from "../../reducers/map/viewport";

const MapEventsHandler = () => {
  const { mapKey, onMapClicked } = useMapContext() || {};

  const dispatch = useDispatch();

  useMapEvents({
    // When the map is clicked, we delegate the click event handling to the map context
    // which will trigger custom registered handlers. This allows child elements to bind
    // the map click event
    click: onMapClicked,
    zoomend: ({ target: map }) => {
      const zoom = map.getZoom();
      dispatch(setMapZoom(mapKey, zoom));
    }
  });

  return null;
};

export default MapEventsHandler;
